exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.range[data-v-506b9b41]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:.5rem 0\n}\ninput[type=range][data-v-506b9b41]{margin:0 .5rem\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/website_dev/src/components/global/Range.vue"],"names":[],"mappings":";AAyBA,wBACE,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,sBAEA,eAAiB;CAClB;AAAA,mCAEC,cAAgB;CACjB","file":"Range.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.range {\n  display:flex;\n  flex-direction: column;\n  // align-items:center;\n  padding : .5rem 0;\n}\ninput[type=range] {\n  margin : 0 .5rem;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-506b9b41","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/Range.vue
// module id = XmtC
// module chunks = 1